import { parseTableLines, extractMarkdownLink, getPhaseClass, isNumeric } from "./parse";
import { EntityChip } from "../EntityChip";
import { PhaseBadge } from "./PhaseBadge";

const ENTITY_URL_PATTERN =
  /(?:map\.combify\.com|staging\.eu-west-1\.combify\.com|localhost(?::\d+)?)\/(property|project|permit|tender)\/([^\s)]+)/;

interface ComparisonTableProps {
  content: string;
  onEntityClick?: (entityType: string, entityId: string, name: string) => void;
}

function CellContent({ text, onEntityClick }: { text: string; onEntityClick?: ComparisonTableProps["onEntityClick"] }) {
  const link = extractMarkdownLink(text);
  if (link && onEntityClick) {
    const entityMatch = link.url.match(ENTITY_URL_PATTERN);
    if (entityMatch) {
      return (
        <EntityChip entityType={entityMatch[1]!} entityId={entityMatch[2]!} onClick={onEntityClick}>
          {link.name}
        </EntityChip>
      );
    }
  }

  if (getPhaseClass(text)) {
    return <PhaseBadge value={text} />;
  }

  return <>{text}</>;
}

export function ComparisonTable({ content, onEntityClick }: ComparisonTableProps) {
  const { headers, rows } = parseTableLines(content);
  if (headers.length === 0) return null;

  const numericCols = headers.map((_, ci) =>
    rows.length > 0 && rows.every((row) => row[ci] !== undefined && isNumeric(row[ci]!))
  );

  return (
    <div className="cx-table-scroll cx-comparison">
      <table>
        <thead>
          <tr>
            {headers.map((h, i) => (
              <th key={i} style={numericCols[i] ? { textAlign: "right" } : undefined}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr key={ri}>
              {row.map((cell, ci) => (
                <td key={ci} style={numericCols[ci] ? { textAlign: "right", fontWeight: 600 } : undefined}>
                  <CellContent text={cell} onEntityClick={onEntityClick} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
